
const ELLIPSIS = '…';

export function fitText(ctx: { measureText(text: string): { width: number } }, text: string, maxPx: number): string {
  if (maxPx <= 0 || ctx.measureText(text).width <= maxPx) return text;
  const chars = Array.from(text);
  let lo = 0;
  let hi = chars.length;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (ctx.measureText(chars.slice(0, mid).join('') + ELLIPSIS).width <= maxPx) lo = mid;
    else hi = mid - 1;
  }
  return lo > 0 ? chars.slice(0, lo).join('') + ELLIPSIS : ELLIPSIS;
}
